import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import type { PartTypeMetricLimits } from "../models/metricLimits.models";

/**
 * Get part types with their metric limits, optionally filtered by parent type IDs.
 * Calls [RBD].[GetPartTypesMetricLimits] stored procedure.
 *
 * @param parentPartTypeIds - Comma-separated parent PartTypeIds (e.g. "3" for Roof, "306,311" for Sidewall).
 *                            When omitted, returns ALL replaceable part types.
 */
export const getPartTypesMetricLimits = async (
  parentPartTypeIds?: string,
  signal?: AbortSignal,
) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = parentPartTypeIds
    ? [{ name: "ParentPartTypeIds", value: parentPartTypeIds }]
    : [];

  return await apiService.callV2(
    "[RBD].[GetPartTypesMetricLimits]",
    parameters,
    signal,
  );
};

/**
 * Upsert metric limits for a part type
 * Calls [RBD].[UpsertPartTypeMetricLimits] stored procedure
 */
export const upsertPartTypeMetricLimits = async (
  limits: PartTypeMetricLimits,
) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [
    { name: "PartTypeId", value: limits.PartTypeId },
    { name: "MetricTypeId", value: limits.MetricTypeId },
    { name: "CampaignWarningLimit", value: limits.CampaignWarningLimit },
    { name: "CampaignAlertLimit", value: limits.CampaignAlertLimit },
    { name: "PartialWarningLimit", value: limits.PartialWarningLimit },
    { name: "PartialAlertLimit", value: limits.PartialAlertLimit },
    { name: "TotalWarningLimit", value: limits.TotalWarningLimit },
    { name: "TotalAlertLimit", value: limits.TotalAlertLimit },
  ];

  return await apiService.callV2(
    "[RBD].[UpsertPartTypeMetricLimits]",
    parameters,
  );
};
